import React from 'react';
import styled from '@emotion/styled';
import { media, mediaQueries, visuallyHidden } from '../../../style/global-style';
import WinnerIcon from '../../../../public/static/icons/winner.svg';
import DreamlinesPackageExpertIcon from '../../../../public/static/icons/dreamlinesPackage-expert.svg';
import ThumbsUpIcon from '../../../../public/static/icons/thumbsUp.svg';
import { DreamlinesButton } from '../../atoms/dreamlines-button/dreamlines-button';
import { getAssetsPrefix } from '../../../utils/buildVersion';

const assetPrefix = getAssetsPrefix();

export const StyledContainer = styled.div`
    width: 100%;
    height: 100%;
    max-height: 425px;
    background-color: ${(props) => props.theme.colors['main1-50']};

    @media ${mediaQueries.tabletAndUp} {
        width: 550px;
        margin: ${(props: { margin: string }) => props.margin};
        height: auto;
        max-height: auto;
        background-color: rgba(0, 35, 59, 0.6);
    }

    @media ${mediaQueries.desktopAndUp} {
        height: 100%;
        max-height: 640px;
        margin: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 550px;
        background-color: rgba(0, 35, 59, 0.5);
    }

    /* IE11 fix */
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        max-height: 100%;
    }
`;

export const StyledSelectWrapper = styled.div`
    display: flex;
    flex-direction: column;

    ${media.tablet`
        flex-direction: row;
    `}

    & > div {
        flex: 1;
        margin-bottom: 10px;
        ${media.tablet`
            width: 50%;
            margin-right: 10px;
        `}
        &:last-child {
            margin-right: 0;
        }
    }
`;

export const StyledInnerContainer = styled.div`
    padding-left: 16px;
    padding-right: 16px;
    margin: 0 auto;
    max-height: 425px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${media.tablet`
      padding: 50px 30px 0 30px;
    `}

    ${media.desktop`
        padding-top: 40px;
        width: 500px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    `}
`;

export const StyledHeadlineInner = styled.div`
    @media ${mediaQueries.phone} {
        display: block;
        text-shadow: 0 0 4px ${(props) => props.theme.dropShadows['black-50']};
        color: ${(props) => props.theme.shades.white};
        padding-top: 0;
        margin-left: -16px;
        margin-right: -16px;
    }

    @media ${mediaQueries.desktopAndUp} {
        display: block;
        text-shadow: 0 0 4px ${(props) => props.theme.dropShadows['black-50']};
        color: ${(props) => props.theme.shades.white};
        padding-top: 20px;
    }
`;

export const ButtonStyled = styled(DreamlinesButton)`
    width: 100%;
    position: relative;
    cursor: pointer;
    padding-left: 20px;
    padding-right: 40px;

    @media ${mediaQueries.allMobileDevices} {
        height: auto;
    }
`;

export const ButtonText = styled.span`
    padding: 0 !important;
    white-space: initial;

    > span {
        padding: 0 !important;
    }
`;

export const StyledPreHeadline = styled.span`
    font-weight: 400;
    font-size: 19px;
    display: block;

    ${media.smallDesktop`
        font-size: 16px;
        font-weight: 400;
    `}
`;

export const StyledHeadline = styled.h1`
    font-size: 30px;
    line-height: 39px;
    padding-top: 24px;
    margin-top: 0;
    margin-bottom: 20px;

    @media ${mediaQueries.allDesktop} {
        font-size: 38px;
        line-height: 40px;
        font-weight: 600;
        letter-spacing: normal;
        padding-left: 0;
        padding-top: 4px;
        margin-bottom: 50px;
        text-shadow: 0 0 6px ${(props) => props.theme.dropShadows['black-50']};
    }
`;

export const StyledHeadlineOutside = styled.div`
    display: none;

    @media ${mediaQueries.tablet} {
        display: block;
        font-size: 57px;
        padding-top: 25px;
        text-align: center;
        font-weight: 600;
        line-height: 1.5;
        text-shadow: 0 0 6px ${(props) => props.theme.dropShadows['black-50']};
        padding-left: ${(props) => props.theme.spacingX.mobile};
        margin-bottom: 30px;
        margin-top: 0;
        color: ${(props) => props.theme.shades.white};

        span {
            font-size: 20px;
            display: block;
        }
    }

    @media ${mediaQueries.smallDesktop} {
        display: block;
        font-size: 57px;
        padding-top: 25px;
        text-align: center;
        font-weight: 600;
        line-height: 1.5;
        text-shadow: 0 0 6px ${(props) => props.theme.dropShadows['black-50']};
        padding-left: ${(props) => props.theme.spacingX.mobile};
        margin-bottom: 30px;
        margin-top: 0;
        color: ${(props) => props.theme.shades.white};

        span {
            font-size: 20px;
            display: block;
        }
    }
`;

export const StyledIconWithTextWrapper = styled.div`
    display: flex;
`;

export const StyledDesktopBagdeContainer = styled.div`
    display: none;

    @media ${mediaQueries.desktopAndUp} {
        border-top: 1px solid ${(props) => props.theme.shades.lightGrey};
        padding-top: 10px;
        padding-bottom: 10px;
        margin: 40px auto 0 auto;
        width: 550px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 12px;
        font-weight: 400px;

        & span {
            padding-left: 10px;
            width: 140px;
            display: flex;
            align-self: center;
        }
    }
`;

export const StyledUspContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 10px;

    ${media.tablet`
      padding: 40px 5px 20px 5px;
      justify-content: space-between;
    `}

    ${media.smallDesktop`
      padding-top: 20px;
    `}

      span {
        font-weight: 600;
        font-size: 16px;
        margin-left: 3px;
        color: ${(props) => props.theme.shades.white};

        ${media.tablet`
          font-size: 13px;
      `}
    }
`;

export const StyledWinner = styled(WinnerIcon)`
    fill: ${(props) => props.theme.shades.white};
    width: 26px;
    height: 26px;
`;

export const StyledThumbsUp = styled(ThumbsUpIcon)`
    fill: ${(props) => props.theme.shades.white};
    width: 18px;
    height: 18px;
    margin-right: 3px;
`;

export const StyledDreamlinesPackageExpert = styled(DreamlinesPackageExpertIcon)`
    fill: ${(props) => props.theme.shades.white};
    width: 21px;
    height: 21px;
    margin-right: 3px;
`;

export const StyledSsl = styled.div`
    width: 50px;
    height: 47px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${assetPrefix}/static/SSL_security.svg');
`;

export const StyledBestPrice = styled.div`
    width: 35px;
    height: 49px;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url('${assetPrefix}/static/bestprice_badge.svg');
`;

export const StyledLabel = styled.label`
    ${visuallyHidden()}
`;
